<template>
    <div>
 <v-dialog
      v-model="dialog"
      width="500"
    >
    
      <template v-slot:activator="{ on, attrs }">
        <v-btn  class="ma-2" v-bind="attrs" v-on="on" >
             <v-icon left>mdi-gavel</v-icon>
                <span>Funções</span>
        </v-btn>
        

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Funções do barbeiro
        </v-card-title>

        <div >
           <v-form class="pa-5" ref="form">
                <v-select
                :items="items"
                item-text="descricao"
                item-value="id"
                v-model="barbeiroAtual.funcoes"
                chips
                label="Serviços"
                multiple
                solo
            ></v-select>
           </v-form>
        </div>

        <v-divider></v-divider>
        <p class="display-5 mx-5 mt-3" >
            Basta selecionar as opções de serviços acima.
        </p>
        <p v-if="items.length == 0" class="display-5 mx-5 red pa-3 white--text" >
            Por favor, vá até a sessão "Funções/Atividades" e crie novas funções
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn  color="primary" text @click="atualizarItem">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
//import firebase from 'firebase'
import {refFuncoes, refBarbeiros} from '@/firebaseConfig'

    export default {
        props: ['barbeiro'],
        data(){
            return {
                dbRef: refFuncoes,
                dbRefBarbeiros: refBarbeiros,
                dialog: false,
                items: [],
                
                barbeiroAtual: {}
                
            }
        },
        created(){
            this.barbeiroAtual = this.barbeiro;
            this.carregarLista();

        },
        methods: {
            carregarLista(){
               // console.log("doc.data()")

               this.items = [];
                this.dbRef.get().then( (snap) => {
                    snap.forEach((doc) => {
                        //console.log(doc.data())
                        this.items.push({...doc.data()});
                    });
                });
            },
            atualizarItem(){
             this.dbRefBarbeiros.doc(this.barbeiroAtual.id)
             .update({funcoes: this.barbeiroAtual.funcoes})
             .then(()=>{
                 this.$emit("recarregarLista");
                 this.dialog = false;
             });
            }
        },
       
    }
</script>

<style lang="scss" scoped>

</style>